export class FeedbackResultViewModel{
    errorCode?: string | undefined;
    exception?: string | undefined;
    errorMessages?: string[] | undefined;
}